export default "/wp-content/themes/oportun/dist/assets/brand/icons-354e2d94e76c44a0.svg"